import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import ErrorFallback from './components/common/ErrorFallback'
import LandingPage from './components/landing/LandingPage'
import LobbyPage from './components/lobby/LobbyPage'
import SessionPage from './components/chat/SessionPage'
import OrgDashboardPage from './components/org/OrgDashboardPage'
import OrgSessionViewer from './components/org/OrgSessionViewer'
import JoinOrgPage from './components/org/JoinOrgPage'
import MySessionsPage from './components/sessions/MySessionsPage'
import SoloStartPage from './components/solo/SoloStartPage'
import PrivacyPolicy from './components/legal/PrivacyPolicy'
import ITWhitelisting from './components/legal/ITWhitelisting'
import TermsOfService from './components/legal/TermsOfService'
import DataProcessingAgreement from './components/legal/DataProcessingAgreement'
import { ToastProvider } from './components/common/Toast'
import { AuthProvider } from './components/auth/AuthProvider'
import Footer from './components/common/Footer'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

const NO_FOOTER_ROUTES = ['/lobby', '/session', '/solo']

function ConditionalFooter() {
  const { pathname } = useLocation()
  if (NO_FOOTER_ROUTES.some(r => pathname.startsWith(r))) return null
  return <Footer />
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ScrollToTop />
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/solo" element={<SoloStartPage />} />
          {/* Old demo links still circulate; send them to the solo front door. */}
          <Route path="/demo" element={<Navigate to="/solo" replace />} />
          <Route path="/sessions" element={<MySessionsPage />} />
          <Route path="/lobby/:sessionId" element={<LobbyPage />} />
          <Route path="/session/:sessionId" element={<SessionPage />} />
          <Route path="/org/:orgId" element={<OrgDashboardPage />} />
          <Route path="/org/join/:inviteCode" element={<JoinOrgPage />} />
          <Route path="/org/:orgId/session/:sessionId" element={<OrgSessionViewer />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/security" element={<ITWhitelisting />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/dpa" element={<DataProcessingAgreement />} />
          {/* Procurement retrieves the exact text they agreed to by version number. */}
          <Route path="/dpa/v1.0" element={<DataProcessingAgreement />} />
        </Routes>
        </Sentry.ErrorBoundary>
        <ConditionalFooter />
      </ToastProvider>
    </AuthProvider>
  )
}
